export const APPLICATION_FORM = "ApplicationForm";
export const POLICE_FORM = "PoliceForm";
export const AFFIDAVIT_FORM = "AffidavitMarriedNoChildren";
export const AFFIDAVIT_NOT_MARRIED = "AffidavitNotMarried";
export const AFFIDAVIT_MARRIED_HAVE_CHILDREN = "AffidavitMarriedHaveChildren";
export const LETTER = "Letter";
export const LETTERENG = "LetterEng";
export const LETTERGEN = "LetterGen";
export const CANDIDATE_FORM = "CandidateForm";